import type { AdPlacement, AdPlacementId } from './types';

export const adPlacements = {
  'hint-reveal': {
    id: 'hint-reveal',
    format: 'rewarded',
    weight: 'light',
    enabled: true,
  },
  continue: {
    id: 'continue',
    format: 'rewarded',
    weight: 'light',
    enabled: true,
  },
  restart: {
    id: 'restart',
    format: 'rewarded',
    weight: 'heavy',
    enabled: true,
  },
  'next-level': {
    id: 'next-level',
    format: 'interstitial',
    weight: 'light',
    enabled: true,
  },
} as const satisfies Readonly<Record<AdPlacementId, AdPlacement>>;
